import { displaySleeveUrl } from '../game/sleeves'
import { useDuelPrefsStore } from '../stores/duelPrefs'

/**
 * Replaced scans keep the old JPEG under the same path in the service worker.
 * A query misses that entry so the board loads the new file.
 */
const CARD_IMAGE_REV: Record<string, string> = {
  '95727991': '5',
  '16768387': '1',
  '52097679': '1',
  '43973174': '1',
}

export function cardImageCacheQuery(cardId: string | number): string {
  const rev = CARD_IMAGE_REV[String(cardId)]
  return rev ? `?v=${rev}` : ''
}

export function getLocalCardImageUrl(cardId: string | number): string {
  const id = String(cardId)
  const path = useDuelPrefsStore().cardArtRegion === 'tcg'
    ? `/card-images/tcg/${id}.jpg`
    : `/card-images/${id}.jpg`
  return `${path}${cardImageCacheQuery(id)}`
}

export const CARD_BACK_URL = '/assets/cards/backs/Back6.webp';

export { displaySleeveUrl }

/** While a duel is running, face-down VFX use the rolled sleeve. */
let duelSleeveUrlOverride: string | null = null

export function setDuelSleeveUrlOverride(url: string | null): void {
  duelSleeveUrlOverride = url
}

/**
 * Player sleeve for Vue menus and face-down flights. Pack opening uses the
 * house card back instead. Random uses default art until a duel rolls.
 */
export function currentSleeveUrl(): string {
  const pref = useDuelPrefsStore().sleeveId
  if (duelSleeveUrlOverride) return duelSleeveUrlOverride
  return displaySleeveUrl(pref)
}
